import {
  createEntityAdapter,
  createSlice,
  createSelector
} from '@reduxjs/toolkit';

import { emptyCampaign } from 'constants/campaignConstants';

const pendingCampaignsAdapter = createEntityAdapter({ selectId: (campaign) => campaign.id });

const initialState = {
  pendingCampaigns: pendingCampaignsAdapter.getInitialState(),
  isLoading: false,
  isLoaded: false
};

// Removed getPendingCampaigns - menu now uses data from main campaigns list

const menuCampaignsSlice = createSlice({
  name: 'menuCampaigns',
  initialState,
  reducers: {
    // Menu campaigns now derive from main campaigns list
    // No need for separate fetch action
  }
});

// Selectors now derive from main campaigns slice
const allPending = createSelector(
  (state) => state.campaigns?.entities || {},
  (campaigns) => {
    // Return first 5 campaigns for menu
    return Object.values(campaigns).slice(0, 5);
  }
);

const byIdPending = (id) =>
  createSelector(
    (state) => state.campaigns?.entities || {},
    (campaigns) => campaigns[id] || emptyCampaign
  );

const selectSelf = (state) => state.campaigns;
const isLoading = createSelector(selectSelf, (state) => state?.isAllLoading || false);
const isLoaded = createSelector(selectSelf, (state) => {
  const entities = state?.entities || {};
  return Object.keys(entities).length > 0;
});

export const MenuCampaignsSelectors = {
  allPending,
  byIdPending,
  isLoading,
  isLoaded
};

export default menuCampaignsSlice.reducer;
